import React from "react"
import isNil from "lodash/isNil"
import { Box, NumberInput } from "@mallardbay/lib-react-components"

export interface Props {
    readonly value: number
    readonly minValue?: number
    readonly maxValue?: number
    readonly setValue: (value: number) => void
    readonly isDisabled?: boolean
    readonly testId?: string
}

export default function NumericInputWithButtons({
    value,
    minValue,
    maxValue,
    setValue,
    isDisabled,
    testId,
}: Props) {
    const styles = useStyles()

    const handleInputChange = (newValue: number) => {
        if (
            (!isNil(minValue) && newValue < minValue) ||
            (!isNil(maxValue) && newValue > maxValue)
        ) {
            return
        }

        setValue(newValue)
    }

    return (
        <Box style={styles.inputWrapper}>
            <NumberInput
                value={value}
                min={minValue}
                max={maxValue}
                onChange={handleInputChange}
                isDisabled={isDisabled}
                testId={testId}
            />
        </Box>
    )
}

function useStyles() {
    return {
        inputWrapper: {
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gridGap: "8px",
            marginTop: { base: "10px", md: 0 },
        },
    }
}
